/* ============================================================================
   LAH — REVELAR O CABECALHO AO APROXIMAR O MOUSE DO TOPO (desktop)
   Tema: Teste de Home

   COMPORTAMENTO
   Com o cabecalho escondido apos rolar para baixo, aproximar o ponteiro da
   faixa superior da tela o traz de volta. Ele PERMANECE visivel mesmo depois
   que o mouse sai dali, e so volta a se esconder na proxima rolagem para
   baixo.

   POR QUE NAO E CSS PURO
   Um :hover em zona fixa resolveria a aparicao, mas o cabecalho sumiria assim
   que o ponteiro saisse — e o pedido e justamente que ele fique. Permanencia
   exige estado, e estado exige JavaScript.

   POR QUE NAO CRIAMOS UMA DIV DE GATILHO
   Uma faixa invisivel de 90px no topo capturaria cliques do conteudo que
   estivesse ali embaixo — na home, exatamente onde ficam a imagem de capa e
   seus links. Em vez disso, observamos a posicao do ponteiro no proprio
   documento: nada e adicionado ao DOM e nada bloqueia clique nenhum.

   CUSTO
   O listener de mousemove e passivo e sai cedo na quase totalidade dos
   eventos: so age quando o estado MUDA. O de scroll idem. Nenhum dos dois
   escreve no DOM em regime normal — apenas na transicao entre mostrar e
   esconder.
   ============================================================================ */

(function () {
    'use strict';

    var PEEK_CLASS = 'lah-header-peek';
    var DESKTOP_MIN_WIDTH = 1000;

    /* Altura da zona sensivel no topo da tela. 90px cobre a area onde o
       cabecalho estaria, com folga suficiente para o gesto ser natural sem
       disparar por acidente no meio da pagina. */
    var PEEK_ZONE_HEIGHT = 90;

    /* Tolerancia do scroll: variacoes de 1 ou 2 pixels acontecem por conta de
       rolagem suave e trackpad, e nao devem contar como "rolou para baixo". */
    var SCROLL_TOLERANCE = 4;

    if (!window.matchMedia('(min-width: ' + DESKTOP_MIN_WIDTH + 'px)').matches) {
        return; /* telas de toque nao tem ponteiro para aproximar */
    }

    var root = document.documentElement;
    var isPeeking = false;
    var lastScrollY = window.scrollY || 0;

    function showHeader() {
        if (isPeeking) return; /* ja visivel: nada a fazer */
        isPeeking = true;
        root.classList.add(PEEK_CLASS);
    }

    function hideHeader() {
        if (!isPeeking) return;
        isPeeking = false;
        root.classList.remove(PEEK_CLASS);
    }

    /* O ponteiro entrou na faixa superior: revela. Fora dela nao fazemos nada
       — e isso que garante a permanencia depois que o mouse se afasta. */
    document.addEventListener('mousemove', function (event) {
        if (event.clientY <= PEEK_ZONE_HEIGHT) {
            showHeader();
        }
    }, { passive: true });

    /* Rolar PARA BAIXO cancela a revelacao — e o unico gesto que esconde de
       novo. Rolar para cima nao mexe: ali o proprio tema ja mostra o
       cabecalho, e interferir causaria conflito entre os dois. */
    window.addEventListener('scroll', function () {
        var currentScrollY = window.scrollY || 0;

        if (currentScrollY > lastScrollY + SCROLL_TOLERANCE) {
            hideHeader();
        }

        lastScrollY = currentScrollY;
    }, { passive: true });

    /* Sair da janela pela parte de cima (indo para a barra de enderecos ou
       para outra aba) tambem revela: o cliente costuma voltar procurando o
       menu, e encontra-lo pronto poupa um movimento. */
    document.addEventListener('mouseleave', function (event) {
        if (event.clientY <= 0) {
            showHeader();
        }
    });
})();
